var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { ToolbarComponent } from './toolbar/toolbar.component';
// import { NavbarComponent } from './navbar/navbar.component';
import { ControlMessagesComponent } from './utilities/control-messages.component';
// import { NameListService } from './name-list/name-list.service';
// import {AuthGuard} from './services/auth-guard.service';
import { ValidationService } from './utilities/validation.service';
import { DateTimeFormatPipe } from './utilities/app.dateformat.pipe';
import { DateFormatPipe } from './utilities/app.formatdate';
// import {dateTimeFormatGMT} from './utilities/app.dateformatGMT.pipe';
/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */
import { SuccessorComponent } from './components/successor/successor';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule_1 = SharedModule;
    SharedModule.forRoot = function () {
        return {
            ngModule: SharedModule_1,
            providers: [
                //   NameListService, AuthGuard,
                ValidationService
            ]
        };
    };
    SharedModule = SharedModule_1 = __decorate([
        NgModule({
            imports: [CommonModule,
                RouterModule,
                FormsModule,
                ReactiveFormsModule,
                AngularMultiSelectModule],
            declarations: [
                //   ToolbarComponent, NavbarComponent, 
                ControlMessagesComponent,
                DateTimeFormatPipe,
                DateFormatPipe,
                SuccessorComponent
            ],
            exports: [
                //   ToolbarComponent, NavbarComponent, 
                ControlMessagesComponent, DateTimeFormatPipe, DateFormatPipe,
                CommonModule, FormsModule, RouterModule, ReactiveFormsModule, SuccessorComponent
            ]
        })
    ], SharedModule);
    return SharedModule;
    var SharedModule_1;
}());
export { SharedModule };



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/shared.module.ts.pre-build-optimizer.js